import { Action, PlainObject, State } from "@zyzgroup/core-common";

function reduce(state: State, payload: PlainObject): State {
  state.tag = payload.tag ? String(payload.tag) : ""; // payload.tag 数据库中为 number
  state.no = payload.no || "";
  state.thirdno = payload.thirdno || "";
  // 经度
  state.longitude =
    typeof payload.longitude == "number" ? payload.longitude : -1;
  // 纬度
  state.latitude = typeof payload.latitude == "number" ? payload.latitude : -1;
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_LOT":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
